var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41999 19.0855C1.13948 19.085 0.872062 18.9667 0.682993 18.7595C0.490439 18.554 0.394758 18.276 0.419993 17.9955L0.664993 15.3015L11.983 3.9875L15.52 7.5235L4.20499 18.8365L1.51099 19.0815C1.47999 19.0845 1.44899 19.0855 1.41999 19.0855ZM16.226 6.8165L12.69 3.2805L14.811 1.1595C14.9986 0.971721 15.2531 0.866211 15.5185 0.866211C15.7839 0.866211 16.0384 0.971721 16.226 1.1595L18.347 3.2805C18.5348 3.46807 18.6403 3.72259 18.6403 3.988C18.6403 4.25341 18.5348 4.50793 18.347 4.6955L16.227 6.8155L16.226 6.8165Z",
    fill: "#0FCC7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6854417a4db3b9fdcff03df5251fca10.svg";
export { ForwardRef as ReactComponent };